 
import http from "@/http/service"
 
export default function ParceiroByid(idParceiro=0){

    return http.get(`/admin/parceiro/${idParceiro}`)

}

